import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { PropTypes } from "prop-types";
import { StyledCalendar } from "../../styles/StyledCalendar";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowDimensions";

export default function Calendar({ data, setDateInfo }) {
	const navigate = useNavigate();
	const { width } = useWindowDimensions();

	return (
		<StyledCalendar>
			<FullCalendar
				aspectRatio={width > 1300 ? 1.5 : 1.3}
				eventClick={(e) => navigate(`/decisions/${e.event._def.extendedProps.decisionId}`)}
				plugins={[dayGridPlugin]}
				eventContent={renderDecisionContent}
				initialView="dayGridMonth"
				events={data}
				expandRows={false}
				dayMaxEventRows={3}
				// dayMaxEvents={true}
				datesSet={(dateInfo) => setDateInfo(dateInfo)}
			/>
		</StyledCalendar>
	);
}

function renderDecisionContent(decisionInfo) {
	let className;

	const status = decisionInfo.event._def.extendedProps.status;
	const slug = status?.slug ?? status?.name?.toLowerCase();
	if (["draft", "ongoing", "done", "archive"].includes(slug)) {
		className = slug;
	}

	return (
		<>
			<div className={className}>
				<span>{decisionInfo.event.title}</span>
			</div>
		</>
	);
}

Calendar.propTypes = {
	data: PropTypes.array,
	setDateInfo: PropTypes.func,
};
